import { combineReducers } from "redux";
import { projectReducer } from "./ProjectReducer";
import { sortReducer } from "./SortReducer";
import { manageReducer } from "./manageReducer";
import { authReducer } from "./AuthReducer";
import { filterReducer } from "./FilterReducer";
import { userInfoReducer } from "./UserInfoReducer";
import { managerMasterReducer } from "./ManagerMaster";
import { FolderLevelReducer } from "./FolderLevelReducer";
import { approveFlowReducer } from "./ApproveFlowReducer";
import { TableCustomReducer } from "./TableCustom";
import { MaillConfirmReducer } from "./MaillConfirm";
import { favoriteProjectInfoReducer } from "./FavoriteProjectInfoReducer";
import { devanSearchReducer } from "./DevanSearchReducer";
import { editTemplateReducer } from "./EditTemplateReducer";
import { incidentDamageReportReducer } from "./IncidentDamageReportReducer";
import { contractReducer } from "./contractReducer";
import { activityBaseIdReducer } from "./activityBaseIdReducer";
import { workSearchReducer } from "./WorkSearchReducer";

export const rootReducer = combineReducers({
  authInfo: authReducer,
  activityBaseId: activityBaseIdReducer,
  managerMaster: managerMasterReducer,
  projectInfo: projectReducer,
  sort: sortReducer,
  manageInfo: manageReducer,
  filter: filterReducer,
  userInfo: userInfoReducer,
  folderLevel: FolderLevelReducer,
  approveFlow: approveFlowReducer,
  tableCustom: TableCustomReducer,
  mailConfirm: MaillConfirmReducer,
  favoriteProjectInfo: favoriteProjectInfoReducer,
  devanSearch: devanSearchReducer,
  editTemplate: editTemplateReducer,
  incidentDamageReport: incidentDamageReportReducer,
  contract: contractReducer,
  workSearch: workSearchReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
